import SearchGuestOrderComponent from "./SearchGuestOrderComponent";

export default class SearchGuestOrderComponentChina extends SearchGuestOrderComponent{

  getFormData(form){
    const phonePrefix=$('#phonePrefix',form).val();
    const orderPhoneNumber=$('#orderPhoneNumber',form).val();
    $('[name="orderPhoneNumber"]',form).val(""+phonePrefix+""+orderPhoneNumber);
    return $(form).serialize();
  }

}
